"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToActionSection = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
var CallToActionSection = function (_a) {
    var actions = _a.actions, fuelType = _a.fuelType, isSmart = _a.isSmart, supplyIndex = _a.supplyIndex;
    var ButtonGroup = (0, core_1.useComponents)().ButtonGroup;
    if (actions.length === 0) {
        return null;
    }
    return (react_1.default.createElement(ButtonGroup, { "data-testid": "meter-reading-summary-card_ctas" }, actions.map(function (action) { return (react_1.default.createElement(CTA, { fuelType: fuelType, isSmart: isSmart, ctaType: action, supplyIndex: supplyIndex, key: action })); })));
};
exports.CallToActionSection = CallToActionSection;
function CTA(_a) {
    var ctaType = _a.ctaType, fuelType = _a.fuelType, isSmart = _a.isSmart, supplyIndex = _a.supplyIndex;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    switch (ctaType) {
        case 'SubmitReading':
            return (react_1.default.createElement("div", { "data-testid": "summary-submit-reading" },
                react_1.default.createElement(Copy, { copyKey: "summarySubmitReading", props: { fuelType: fuelType, isSmart: isSmart, supplyIndex: supplyIndex } })));
        case 'ViewHistory':
            return (react_1.default.createElement("div", { "data-testid": "summary-view-history" },
                react_1.default.createElement(Copy, { copyKey: "summaryViewHistory", props: { fuelType: fuelType, supplyIndex: supplyIndex } })));
    }
}
